import { Box, Container, createStyles, Text } from "@mantine/core";
import React from "react";
import { SUPPORT_EMAIL } from "./constants";

const LOGIN_BACKGROUND_URL =
  "https://imagedelivery.net/THJz7cQLDDpzn89AEYAkbg/371b9156-947f-4c3b-d433-68161846f600/public";
const TERMS_OF_USE_URL = "https://jemhr.com/terms-of-service";
const MARKETING_SITE_URL = "https://jemhr.com";

const useStyles = createStyles((theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "100vh",
    maxWidth: "100%",
    margin: 0,
    backgroundImage: `url("${LOGIN_BACKGROUND_URL}")`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    position: "relative",
  },
  footer: {
    fontFamily: "Inter, sans-serif",
    position: "absolute",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    bottom: 0,
    color: theme.white,
    textAlign: "center",
    padding: "0px 45px",
    height: "80px",
    "& a": {
      color: theme.white,
      fontSize: "18px",
      fontWeight: 500,
    },
    "& div": {
      fontSize: "18px",
      fontWeight: 500,
    },
    "@media (max-width: 830px)": {
      "& a": {
        fontSize: "16px",
      },
      "& div": {
        fontSize: "16px",
      },
    },
  },
  copyrightText: {
    textAlign: "left",
    width: "200px", // Each element on either side of email need to have same width to center text
  },
  footerLinks: {
    width: "200px", // Each element on either side of email need to have same width to center text
  },
  jemHRLink: {
    borderRight: "1px solid white",
    paddingRight: "30px",
    marginRight: "30px",
    "@media (max-width: 970px)": {
      paddingRight: "20px",
      marginRight: "20px",
    },
  },
  emailBreak: {
    display: "none",
    "@media (max-width: 970px)": {
      display: "block",
    },
  },
}));

const Footer: React.FC = () => {
  const { classes } = useStyles();
  const year = new Date().getFullYear();

  return (
    <Box className={classes.footer}>
      <Text className={classes.copyrightText} size="sm">
        &copy; Jem HR {year}
      </Text>

      <Text>
        Need assistance?&nbsp;
        <br className={classes.emailBreak} />
        Email <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>
      </Text>

      <Box className={classes.footerLinks}>
        <Text
          className={classes.jemHRLink}
          component="a"
          href={MARKETING_SITE_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          jemhr.com
        </Text>
        <Text
          component="a"
          href={TERMS_OF_USE_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          Terms
        </Text>
      </Box>
    </Box>
  );
};

const LoginPageWrapper: React.FC = ({ children }) => {
  const { classes } = useStyles();

  return (
    <Container className={classes.container}>
      {children}
      <Footer />
    </Container>
  );
};

export default LoginPageWrapper;
